import { t } from 'i18next';
import { enforce, test } from 'vest';

import { FormUtils } from '@anyx/shared-utils';


import { PlainTextBlock } from '../types';

export const plainTextValidatorBuilder = (index: number) => (message: PlainTextBlock) => {
  test(
    `messages.${index}.text`,
    FormUtils.requiredField(
      t('crm.lineMessageForm.fields.text.label', {
        ns: 'crm',
      })
    ),
    () => {
      enforce(message.text).isNotBlank();
    },
    `plainText-${index}-text`
  );
};
